function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.32306 7.24605H6.10771V6.5076H8.32306V7.24605Z",
  fill: "#121221"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.79995 10.1998H7.58461V9.46139H9.79995V10.1998Z",
  fill: "#121221"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.06151 8.72294H6.84616V7.98449H9.06151V8.72294Z",
  fill: "#121221"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.00112 7.24605C4.99852 6.9345 4.91542 6.62892 4.7599 6.35895C4.60438 6.08899 4.38171 5.86381 4.1135 5.70527L6.84613 0.969231L6.20738 0.600006L3.40976 5.44645C3.06642 5.36974 2.70933 5.38035 2.37114 5.4773C2.03296 5.57424 1.72448 5.75444 1.47392 6.00139C0.0915408 7.33466 0.198616 10.4517 0.203785 10.5838C0.207602 10.6792 0.248181 10.7693 0.317014 10.8354C0.385848 10.9015 0.477591 10.9384 0.57301 10.9383H6.10805C6.18555 10.9383 6.26108 10.9139 6.32394 10.8686C6.38681 10.8233 6.43383 10.7593 6.45833 10.6858C6.48284 10.6123 6.48359 10.5329 6.46048 10.459C6.43738 10.385 6.39158 10.3202 6.32959 10.2737C5.02253 9.29303 5.00112 7.26598 5.00112 7.24605ZM3.12804 6.13726C3.42356 6.14051 3.70645 6.25757 3.91785 6.46409C4.12925 6.67061 4.25289 6.95068 4.26304 7.24605C4.26304 7.26008 4.26378 7.32284 4.26932 7.41921L2.09089 6.45037C2.23439 6.33204 2.39998 6.24342 2.57803 6.18967C2.75608 6.13592 2.94304 6.11811 3.12804 6.13726ZM4.42771 10.1998C4.13259 9.89933 3.94447 9.51012 3.89234 9.09217H3.15389C3.18033 9.48512 3.30308 9.86554 3.5113 10.1998H2.69051C2.53867 9.72067 2.44629 9.22465 2.41544 8.72294H1.67699C1.7008 9.22315 1.78321 9.71884 1.92253 10.1998H0.938542C0.949988 9.52194 1.04562 8.02437 1.60425 7.04186L4.38562 8.27877C4.51926 8.97265 4.80416 9.62856 5.22007 10.1998H4.42771Z",
  fill: "#121221"
});

function SvgCleaningTiny(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleaningTiny);
export default __webpack_public_path__ + "static/media/CleaningTiny.c3760cad.svg";
export { ForwardRef as ReactComponent };